import React from 'react';
import styled, { keyframes } from "styled-components";

const slideFromLeft = keyframes`
  from {
    transform: translateX(-120px);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const PresentationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  padding: 0 20px;

  animation: ${slideFromLeft} 1.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;
`;

const HiText = styled.h1`
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: clamp(18px, 2.6vw, 24px);
  color: #666666;
  margin-top: 20px;
  margin-left: 80px;

  @media (max-width: 600px) {
    margin-left: 0;
    margin-top: 56px;
  }

  @media (max-width: 375px) {
    font-size: 18px;
    margin-top: 40px;
  }

  @media (max-width: 320px) {
    font-size: 16px;
    margin-top: 32px;
  }
`;

const NameText = styled.h2`
  font-family: "Playfair Display", serif;
  font-weight: 500;
  font-size: clamp(32px, 6.5vw, 60px);
  color: #333333;
  margin-top: 10px;

  @media (max-width: 375px) {
    font-size: 36px;
    margin-top: 8px;
  }

  @media (max-width: 320px) {
    font-size: 30px;
  }
`;

function PresentationL() {
  return (
    <PresentationContainer>
      <HiText>Hi, Im</HiText>
      <NameText>Carolina</NameText>
    </PresentationContainer>
  );
}

export default PresentationL;